import Fetch from './_utils';
import {
  CreatePushSubscriptionType,
  PushPresenceType,
  PushPreferencesType,
  PushSubscriptionType,
  UpdatePushPreferencesType,
} from '@/constants/types/models/notification/PushNotification';

/** Web Push (notifications/ en la API). Todo detrás del flag `web_push_notifications`. */
export const PUSH_PREFERENCES_QUERY_KEY = [
  'notifications',
  'push',
  'preferences',
] as const;

export const getPushPreferencesService = async (params?: {
  signal?: AbortSignal;
}) => {
  const response = await Fetch(
    'notifications/preferences/',
    { method: 'GET' },
    true,
    false,
    [params?.signal]
  );
  if (response.ok) {
    return (await response.json()) as PushPreferencesType;
  }
  throw new Error('Error');
};

export const updatePushPreferencesService = async (
  params: UpdatePushPreferencesType
) => {
  const response = await Fetch('notifications/preferences/', {
    method: 'PATCH',
    body: JSON.stringify(params),
  });
  if (response.ok) {
    return (await response.json()) as PushPreferencesType;
  }
  throw new Error('Error');
};

export const PUSH_SUBSCRIPTIONS_QUERY_KEY = [
  'notifications',
  'push',
  'subscriptions',
] as const;

export const getPushSubscriptionsService = async (params?: {
  signal?: AbortSignal;
}) => {
  const response = await Fetch(
    'notifications/subscriptions/',
    { method: 'GET' },
    true,
    false,
    [params?.signal]
  );
  if (response.ok) {
    return (await response.json()) as PushSubscriptionType[];
  }
  throw new Error('Error');
};

export const subscribePushService = async (
  params: CreatePushSubscriptionType
) => {
  const response = await Fetch('notifications/subscriptions/', {
    method: 'POST',
    body: JSON.stringify(params),
  });
  if (response.ok) {
    return (await response.json()) as PushSubscriptionType;
  }
  throw new Error('Error');
};

export const unsubscribePushService = async (params: { endpoint: string }) => {
  const response = await Fetch('notifications/subscriptions/', {
    method: 'DELETE',
    body: JSON.stringify(params),
  });
  if (response.ok) {
    return true;
  }
  throw new Error('Error');
};

export const sendTestPushService = async () => {
  const response = await Fetch('notifications/test/', { method: 'POST' });
  if (response.ok) {
    return (await response.json()) as { sent: number };
  }
  throw new Error('Error');
};

/**
 * Presencia por dispositivo (CONTRACT §2/§5): `visible: true` marca este dispositivo como
 * "BO a la vista" (TTL 75 s en SAPI) y `false` lo borra. Responde 204. Con `keepalive`
 * sobrevive a `pagehide`. Nunca lanza: es best effort.
 */
export const postPresenceService = async (
  params: PushPresenceType,
  options?: { keepalive?: boolean }
): Promise<boolean> => {
  try {
    const response = await Fetch('notifications/presence/', {
      method: 'POST',
      body: JSON.stringify(params),
      keepalive: options?.keepalive,
    });
    return response.ok;
  } catch {
    return false;
  }
};
